import React from 'react';
import { CheckIcon } from 'lucide-react';
import { finalInclusions } from '../data/content';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function FinalCta() {
  return <>
      <section className="bg-navy py-16 sm:py-24" data-id="element-131" data-mp="19fqljqoyjhcm">
        <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-132" data-mp="15ddkvgp2i9mp">
          <h2 className="text-balance font-display text-[30px] font-bold leading-[1.12] text-white sm:text-5xl" data-id="element-133" data-mp="15c2d75si4hqb">
            Ready to Organize Your Third Molar Assessments?
          </h2>
          <div className="mt-5 space-y-3 text-[17px] leading-relaxed text-white/80" data-id="element-134" data-mp="1edipxk6sgvxp">
            <p data-id="element-135" data-mp="1t1wsrv47gke9">You don’t necessarily need another collection of disconnected notes.</p>
            <p data-id="element-136" data-mp="1o3lgldqftxsv">
              You may benefit from a visual framework that helps you navigate the information you already have, organize your initial
              assessment, and document the questions that still need attention.
            </p>
          </div>

          <p className="mt-8 font-bold text-white" data-id="element-137" data-mp="1x2p2epgzorb2">With Third Molar Assessment Blueprint™, you’ll receive:</p>
          <ul className="mx-auto mt-4 grid max-w-2xl gap-2.5 text-left sm:grid-cols-2 sm:gap-x-8" data-id="element-138" data-mp="s4fkxxy9413m">
            {finalInclusions.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white" data-id="element-139" data-mp="x2z5btx754tv">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-140" data-mp="123mxiix5vrpo" />
                {item}
              </li>)}
          </ul>

          <p className="mx-auto mt-8 max-w-2xl text-[17px] leading-relaxed text-white/80" data-id="element-141" data-mp="1b3a21dl6tdmy">
            I created Third Molar Assessment Blueprint™ to help you bring more structure to your third molar learning and assessment
            process. If that’s what you’ve been looking for, I invite you to explore the complete collection.
          </p>

          <p className="mt-10 text-sm font-bold uppercase tracking-[0.14em] text-sky" data-id="element-142" data-mp="1pu0tulms4cq2">
            Get the Complete Third Molar Assessment Blueprint™ Today
          </p>
          <p className="mt-2 font-display text-6xl font-bold text-white sm:text-7xl" data-id="element-143" data-mp="3qtvzej24veiv">
            Just <span className="text-cta" data-id="element-144" data-mp="3lw43ldydb89e">$27</span> <span className="text-2xl" data-id="element-145" data-mp="3lx5jbvqbwixg">USD</span>
          </p>
          <p className="mt-2 text-sm text-white/70" data-id="element-146" data-mp="3i4lkim56so0">One-Time Payment · Instant Digital Access · 7-Day Guarantee</p>

          <div className="mt-8" data-id="element-147" data-mp="3uv7o8md6nvq0">
            <CtaButton tone="dark" label="Yes, I Want the Third Molar Assessment Blueprint™" sub={null} data-id="element-148" data-mp="3uu62nnyjjqu1" />
          </div>
          <Countdown tone="dark" data-id="element-149" data-mp="8godr0rbx0ot" />
        </div>
      </section>

      <footer className="bg-navyDeep px-4 pb-32 pt-12 text-center sm:pb-28" data-id="element-150" data-mp="8g6ahk691m7e">
        <p className="font-display text-xl font-bold text-white" data-id="element-151" data-mp="mffnyc32m27o">Third Molar Assessment Blueprint™</p>
        <p className="mt-2 text-sm text-white/70" data-id="element-152" data-mp="ig6ul8by06cn">Organize the information. Connect the concepts. Structure your assessment.</p>
        <p className="mt-1 text-sm text-white/70" data-id="element-153" data-mp="2o83rkmjmmrnz">Created by Dr. Nathan Brooks.</p>
        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-white/50" data-id="element-154" data-mp="2k7tcmkduwqwz">
          Educational resource only. This product does not replace formal training, current scientific evidence, specialist consultation,
          comprehensive clinical evaluation, or patient-specific professional judgment.
        </p>
        <p className="mt-4 text-xs text-white/50" data-id="element-155" data-mp="20ae9ccgm9pb5">© 2026 · Third Molar Assessment Blueprint™ · All rights reserved.</p>
      </footer>
    </>;
}